export function getDateAfterDay(date: Date, afterDay: number): Date {
  return new Date(new Date(date).setDate(new Date(date).getDate() + afterDay));
}
